import { CSSProperties, FC, ReactNode, useMemo } from 'react';

import {
  Divider,
  IconButton,
  Typography,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import classes from './FullscreenDialog.module.scss';

export interface FullscreenDialogProps {
  isOpen: boolean;
  close: () => void;
  contentWidth: string;
  title: ReactNode;
  children?: ReactNode;
  dialogTestId?: string;
  titleTestId?: string;
  closeTestId?: string;
  actions?: ReactNode;
}

export const FullscreenDialog: FC<FullscreenDialogProps> = ({
  isOpen,
  contentWidth,
  close,
  title,
  dialogTestId,
  titleTestId,
  closeTestId,
  children,
  actions,
}) => {
  const contentStyle = useMemo(
    (): CSSProperties => ({
      width: contentWidth,
    }),
    [contentWidth],
  );

  return isOpen ? (
    <div className={classes.container} data-testid={dialogTestId}>
      <div className={classes.header}>
        <IconButton
          iconName={Icons.Close}
          onClick={close}
          dataTestId={closeTestId}
        />
      </div>
      <Divider />
      <div className={classes.title} style={contentStyle}>
        <Typography variant='h5' data-testid={titleTestId}>
          {title}
        </Typography>
      </div>
      <div className={classes.body} style={contentStyle}>
        <div className={classes.content}>{children}</div>
      </div>
      <Divider />
      <div className={classes.footer}>
        <div className={classes.footerContent} style={contentStyle}>
          {actions}
        </div>
      </div>
    </div>
  ) : null;
};
